import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import CreateTemplate from "./routes/CreateTemplate";
export default store => ({
  path: ":subject_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [CreateTemplate(store)],
});
